import EventEmitter from 'events';
import axios from 'axios';
import Symbol from 'es6-symbol/polyfill';

let singleton = Symbol();
let singletonEnforcer = Symbol();
class SalesForceService extends EventEmitter {
  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this._instance = axios.create();
    this._cancelToken = axios.CancelToken;
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new SalesForceService(singletonEnforcer);
    }
    return this[singleton];
  }

  async getCompaniesByDatas(name, zipCode) {
    if(this.cancel) this.cancel();
    zipCode = zipCode.substr(0, 2);
    const query = `query getAccount {
      uiapi {
        query {
          Account (where: {
            Name:{like:"%${name}%"}
            BillingPostalCode: {like:"${zipCode}%"}
          }) {
            edges {
              node {
                Id #identifiant Salesforce
                Name {value}
                RecordType {Name{value}} #type du compte : Prospect, Customer…
                SicDesc {value}
                TECH_Branch__c {value}
                TECH_SoprasolarActivity__c {value}
                Owner {Name {value}}
                Phone {value}
                Company_type__c {value} #table métier
                BillingStreet {value}
                BillingPostalCode {value}
                BillingCity {value}
                BillingCountry {value}
              }
            }
          }
        }
      }
    }`;
    const response = await this._instance({
      method: 'POST',
      url: window.Routing.generate('app_api_salesforce_graphql'),
      data: { query },
      cancelToken: new this._cancelToken( (c) => {
        this.cancel = c;
      })
    })
    return this._parseCompanies(response.data);
  }

  async getContacts(email) {
    // AccountId: {eq:"${companyId}"}
    const query = `query getContact {
      uiapi {
        query {
          Contact (where: {
            Email: {eq:"${email}"}
          }) {
            edges {
              node {
                Id #identifiant Salesforce
                FirstName {value}
                LastName {value}
                Email {value}
                Phone {value}
                MobilePhone {value}
                Account {Name {value}}
                Account {SicDesc {value}}
              }
            }
          }
        }
      }
    }`;
    const response = await this._instance({
      method: 'POST',
      url: window.Routing.generate('app_api_salesforce_graphql'),
      data: { query }
    })
    return this._parseContacts(response.data);
  }

  async getCompaniesBySirenSiret(sirenOrSiret, zipCode = null) {
    if(this.cancel) this.cancel();
    let whereRequest = `{
            SicDesc:{eq:"${ sirenOrSiret }"}
          }`;
    if(zipCode) {
      zipCode = zipCode.substr(0, 2);
      whereRequest = `{
            SicDesc:{like:"${ sirenOrSiret }%"}
            BillingPostalCode:{like:"${ zipCode }%"}
          }`;
    }
    const query = `query getAccount {
      uiapi {
        query {
          Account (where: ${whereRequest}) {
            edges {
              node {
                Id #identifiant Salesforce
                Name {value}
                RecordType {Name{value}} #type du compte : Prospect, Customer…
                SicDesc {value}
                TECH_Branch__c {value}
                TECH_SoprasolarActivity__c {value}
                Owner {Name {value}}
                Phone {value}
                Company_type__c {value} #table métier
                BillingStreet {value}
                BillingPostalCode {value}
                BillingCity {value}
                BillingCountry {value}
              }
            }
          }
        }
      }
    }`;
    const response = await this._instance({
      method: 'POST',
      url: window.Routing.generate('app_api_salesforce_graphql'),
      data: { query },
      cancelToken: new this._cancelToken( (c) => {
        this.cancel = c;
      })
    })
    return this._parseCompanies(response.data);
  }

  async setCompany(datas) {
    const response = await this._instance({
      method: 'POST',
      url: window.Routing.generate('app_api_salesforce_prospect'),
      data: {
        account: {
          ...datas
        }
      }
    })
    return JSON.parse(response.data);
  }

  async setContact(datas) {
    const response = await this._instance({
      method: 'POST',
      url: window.Routing.generate('app_api_salesforce_primary_contact'),
      data: {
        contact: {
          ...datas
        }
      }
    })
    return JSON.parse(response.data);
  }

  _parseCompanies(datas) {
    const companies = datas.data.uiapi?.query?.Account?.edges;
    if(companies) {
      return datas.data.uiapi?.query?.Account?.edges?.map((company) => {
        company = company?.node;
        return company;
      });
    }
    return [];
  }

  _parseContacts(datas) {
    const contacts = datas.data.uiapi?.query?.Contact?.edges;
    if(contacts && contacts.length > 0) {
      return datas.data.uiapi?.query?.Contact?.edges[0].node;
    }
    return null;
  }

}
export default SalesForceService.getInstance();
